import { MessageType, RawMessage, RawTextMessage } from "@/store/chats/types";

export const getIsRawMessageTextType = (
  message: RawMessage,
): message is RawTextMessage =>
  // to support legacy messages with no type
  !message?.messageType || message.messageType === MessageType.Text;
